import React, { Fragment, useContext, useState } from "react";
import { Drawer, Button, Space, Row, Col } from "antd";
import { MenuOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { Avatar, Badge, Menu } from "antd";
import {
  HomeOutlined,
  GiftOutlined,
  NotificationOutlined,
  SettingOutlined,
  CloseOutlined,
  LogoutOutlined,
  UserOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";
import Search from "antd/lib/input/Search";
import { makeStyles } from "@material-ui/styles";
import { MenuContext } from "../../context/carritoContext";
import jwt_decode from "jwt-decode";
import aws from "../../config/aws";
import { Link, withRouter } from "react-router-dom";
import { formatoMexico } from "../../config/reuserFunction";

const { SubMenu } = Menu;

function NavbarResponsive(props) {
  const [visible, setVisible] = useState(false);
  const { colores, datosContx } = useContext(MenuContext);
  const token = localStorage.getItem("token");
  var decoded = Jwt(token);
 /*  let saldo =
    decoded && decoded.datos_socio ? decoded.datos_socio.saldodisponible : null; */
 /*  let linea =
    decoded && decoded.datos_socio ? decoded.datos_socio.tienelinea : false; */

  function Jwt(token) {
    try {
      return jwt_decode(token);
    } catch (e) {
      return null;
    }
  }

  const useStyles = makeStyles({
    background: {
      backgroundColor: colores.navPrimary.background,
      fontSize: "18px",
    },
    logoContainer: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      height: "80px",
    },
    imgLogo: {
      maxWidth: "100%",
      maxHeight: "100%",
    },
  });

  const classes = useStyles();

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <Fragment>
      {decoded ? decoded.rol === true ? null : (
        <div style={{ paddingTop: 8, paddingBottom: 8, textAlign: "center" }}>
          { `Hola, ${decoded.nombre}`}
        </div>
      ): null}
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="space-around">
        <Col span={3}>
          <Button
            type="text"
            onClick={showDrawer}
            icon={<MenuOutlined />}
            size="large"
            className="d-flex align-items-center justify-content-center"
          />
        </Col>
        <Col span={18}>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100%" }}
          >
            <Search
              placeholder="Buscar... "
              onSearch={(value) => props.history.push(`/searching/${value}`)}
            />
          </div>
        </Col>
        <Col span={3}>
          {!decoded || decoded.rol === true ? null : (
            <Button
              type="text"
              icon={<ShoppingCartOutlined style={{ fontSize: 22 }} />}
              size="large"
              className="d-flex align-items-center justify-content-center"
              onClick={() => props.history.push("/shopping_cart")}
            />
          )}
        </Col>
      </Row>

      <Drawer
        placement="left"
        width={280}
        onClose={onClose}
        closeIcon={false}
        visible={visible}
        extra={
          <Space>
            <Button onClick={onClose} shape="circle" icon={<CloseOutlined />} size="large" />
          </Space>
        }
      >
        <Menu className={classes.background}>
          <Menu.Item onClick={() => onClose()} key="/" icon={<HomeOutlined />}>
            Inicio
            <Link to="/" />
          </Menu.Item>
          <Menu.Item
            onClick={() => onClose()}
            key="/productos"
            icon={<GiftOutlined />}
          >
            Productos
            <Link to="/productos" />
          </Menu.Item>
          {datosContx.ofertas ? (
            <Menu.Item
              onClick={() => onClose()}
              key="/ofertas"
              icon={<NotificationOutlined />}
            >
              Ofertas
              <Link to="/ofertas" />
            </Menu.Item>
          ) : null}
          {!decoded || decoded.rol === true ? (
            <Menu.Item key="" className="d-none" />
          ) : (
            <Menu.Item
              onClick={() => onClose()}
              className={classes.background + " " + classes.hover}
              key="/shopping_cart"
            >
              <Badge count={datosContx.carritoCantidad}>
                <ShoppingOutlined
                  style={{ fontSize: 22 }}
                  className={classes.background + " " + classes.hover}
                />
                <Link to="/shopping_cart" />
              </Badge>
            </Menu.Item>
          )}
          {token && decoded["rol"] === false ? (
            <SubMenu
              icon={
                !decoded.imagen && !decoded.imagenFireBase ? (
                  <Avatar size="large" style={{ backgroundColor: "#87d068" }}>
                    <p>{decoded.nombre.charAt(0)}</p>
                  </Avatar>
                ) : decoded.imagenFireBase ? (
                  <Avatar size="large" src={decoded.imagenFireBase} />
                ) : (
                  <Avatar size="large" src={aws + decoded.imagen} />
                )
              }
            >
              {!decoded || decoded.rol === true ? (
                <Menu.Item key="" className="d-none" />
              ) : (
                <Menu.Item onClick={() => onClose()} key="/pedidos">
                  <ShoppingOutlined /> Mis Apartados
                  <Link to="/pedidos" />
                </Menu.Item>
              )}
              <Menu.Item onClick={() => onClose()} key="perfiles">
                <SettingOutlined />
                Mi cuenta
                <Link to="/perfiles" />
              </Menu.Item>
              <Menu.Item>
                <div
                  onClick={() => {
                    localStorage.removeItem("token");
                    window.location.reload();
                  }}
                >
                  <LogoutOutlined />
                  Cerrar Sesión
                </div>
              </Menu.Item>
            </SubMenu>
          ) : decoded && decoded["rol"] === true ? (
            <SubMenu
              icon={
                !decoded.imagen ? (
                  <Avatar size="large" style={{ backgroundColor: "#87d068" }}>
                    <p>{decoded.nombre.charAt(0)}</p>
                  </Avatar>
                ) : (
                  <Avatar size="large" src={aws + decoded.imagen} />
                )
              }
            >
              <Menu.Item key="admin">
                <SettingOutlined />
                Panel de administrador
                <Link to="/admin" />
              </Menu.Item>
              <Menu.Item key="sesion">
                <div
                  onClick={() => {
                    localStorage.removeItem("token");
                    window.location.reload();
                  }}
                >
                  <LogoutOutlined />
                  Cerrar Sesión
                </div>
              </Menu.Item>
            </SubMenu>
          ) : (
            <Menu.Item key="" className="d-none" />
          )}
          {token === "" || token === null ? (
            <Menu.Item onClick={() => onClose()} key="entrar">
              <div>
                <UserOutlined style={{ fontSize: 27 }} />
              </div>
              <Link to="/entrar" />
            </Menu.Item>
          ) : (
            <Menu.Item key="" className="d-none" />
          )}
        </Menu>
      </Drawer>
    </Fragment>
  );
}

export default withRouter(NavbarResponsive);
